var components = {
  uTag: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-tag/u-tag" */ "uview-ui/components/u-tag/u-tag.vue"
    )
  },
  uIcon: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
    )
  },
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }